import gql from 'graphql-tag'

export default gql`
mutation removeActivities($_id: [MongoID!]!, $eventId: String, $reason: String) {
  removeActivities(_id: $_id, eventId: $eventId, reason: $reason) {
    checkStatus
    deletedCount
    loggedCount
    batchId
    deletedIds
    notFoundIds
  }
}
`
